import Vue from 'vue'
import Router from 'vue-router'
import {getToken} from '@/utils/auth' 
import {setStatusBar} from '@/utils/index' 
import store from '@/store'
import {httpGetInitInfo,httpGetUserInfo} from "@/api/login";

Vue.use(Router)

const needLoginList = ['/coinPurse','/dappwallet','/send','/against','/receive','/addressBook','/addAddress','/historyNotice','/setUp','/coinDetail','/payPassword','/share','/mywealth','/ploydetail','/buyploy','/sellploy','/query','/plandetail','/sendEnvelope', '/buyAU'
    ] // no redirect whitelist

const router = new Router({
  //mode: "history",
  routes: [{
      path: '/',
      redirect: '/index/home'
    },
    {
      path: '/index',
      redirect: '/index/home'
    },
	{
	  path: '/relogin',
	  name: 'Reogin',
	  component: () => import('./views/Relogin.vue')
	},
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: () => import('./views/Login.vue')
    // },
    {
      path: '/register',
      name: 'Register',
      component: () => import('./views/Register.vue')
    },
    {
      path: '/forget',
      name: 'Forget',
      component: () => import('./views/Forget.vue')
    },
    {
      path: '/password',
      name: 'Password',
      component: () => import('./views/Password.vue')
    },
    {
      path: '/index',
      name: 'Index',
      component: () => import('./views/Index.vue'),
      children: [
        // 当 /user/:id 匹配成功，
        // UserHome 会被渲染在 User 的 <router-view> 中
        { path: 'home', component: () => import('./views/index/Home.vue') },
        { path: 'hd-wallet', component: () => import('./views/index/hdWallet/Index.vue') },

        { path: 'market', component: () => import('./views/hangqing/Index.vue') },
        { path: 'package', component: () => import('./views/package/Index.vue') },
        { path: 'premmt', component: () => import('./views/index/Premmt.vue') },
        {
          path: 'premmt-history',
          name: 'PremmtHistory',
          component: () => import('@/views/index/PremmtHistory.vue')
        },
        {
          path: 'premmt-prize-history',
          name: 'PremmtPrizeHistory',
          component: () => import('@/views/index/PremmtPrizeHistory.vue')
        },
        { path: 'package-orders', component: () => import('./views/package/Order.vue') },
        { path: 'package-orders-detail', component: () => import('./views/package/OrderDetail.vue') },
        { path: 'wealth', component: () => import('./views/wealth/Index.vue') },
        { path: 'find', component: () => import('./views/faxian/Index.vue') },
        { path: 'mypage', component: () => import('./views/wode/Index.vue') },
        { path: 'nologin', component: () => import('./views/NoLogin.vue') },
        { path: '*', redirect: '/404' }
        // ...其他子路由
      ]
      
    },
    {
      path: '/coinList',
      name: 'CoinList',
      component: () => import('./views/index/CoinList.vue')
    },
    {
      path: '/hangqing',
      name: 'Hangqing',
      component: () => import('./views/hangqing/Index.vue')
    },
    {
      path: '/coinPurse',
      name: 'CoinPurse',
      component: () => import('./views/index/CoinPurse.vue')
      
    },
    {
      path: '/send',
      name: 'Send',
      component: () => import('./views/index/Send.vue')
    },
    {
        path: '/hd-send',
        name: 'Hd Wallet Send',
        component: () => import('./views/index/hdWallet/HdSend.vue')
      },
    {
      path: '/against',
      name: 'Against',
      component: () => import('./views/index/Against.vue')
    },
    {
      path: '/lottery',
      name: 'Lottery',
      component: () => import('./views/index/Lottery.vue')
    },
    {
      path: '/receive',
      name: 'Receive',
      component: () => import('./views/index/Receive.vue')
    },
    {
        path: '/hd-receive',
        name: 'Hd Wallet Receive',
        component: () => import('./views/index/hdWallet/HdReceive.vue')
      },
    {
      path: '/addressBook',
      name: 'AddressBook',
      component: () => import('./views/index/AddressBook.vue'),
      
    },
    {
      path: '/addAddress',
      name: 'AddAddress',
      component: () => import('./views/index/AddAddress.vue'),
      
    },
    {
      path: '/historyNotice',
      name: 'HistoryNotice',
      component: () => import('./views/index/HistoryNotice.vue'),
      
    },
    {
      path: '/setUp',
      name: 'SetUp',
      component: () => import('./views/index/SetUp.vue'),
      
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import('./views/index/Search.vue')
    },
    {
      path: '/coinDetail',
      name: 'CoinDetail',
      component: () => import('./views/index/CoinDetail.vue')
    },
    {
      path: '/payPassword',
      name: 'PayPassword',
      component: () => import('./views/index/PayPassword.vue')
    },
    {
      path: '/rePayPassword',
      name: 'RePayPassword',
      component: () => import('./views/index/RePayPassword.vue')
    },
    {
      path: '/forgetPayPass',
      name: 'ForgetPayPass',
      component: () => import('./views/index/ForgetPayPass.vue')
    },
    {
      path: '/googleCode',
      name: 'GoogleCode',
      component: () => import('./views/index/GoogleCode.vue')
    },
    {
      path: '/googleCheck',
      name: 'GoogleCheck',
      component: () => import('@/views/wode/GoogleCheck.vue')
    },
    {
      path: '/fontSizeSettings',
      name: 'FontSizeSettings',
      component: () => import('./views/index/FontSize.vue')
    },
    {
      path: '/firstSetPayPassword',
      name: 'FirstSetPayPassword',
      component: () => import('./views/index/FirstSetPayPassword.vue')
    },
    {
      path: '/codeCheck',
      name: 'CodeCheck',
      component: () => import('./views/index/CodeCheck.vue')
    },
    {
      path: '/editPayPassword',
      name: 'EditPayPassword',
      component: () => import('./views/index/EditPayPassword.vue')
    },
    {
      path: '/setPayPassword',
      name: 'SetPayPassword',
      component: () => import('./views/index/SetPayPassword.vue')
    },
    {
      path: '/googleValid',
      name: 'GoogleValid',
      component: () => import('./views/index/GoogleValid.vue')
    },
    {
      path: '/securityLevel',
      name: 'SecurityLevel',
      component: () => import('./views/index/SecurityLevel.vue')
    },
    {
      path: '/levelThreeApply',
      name: 'RealNameApply',
      component: () => import('./views/index/RealNameApply.vue')
    },
	{
	  path: '/levelThreeApply3',
	  name: 'RealNameApply3',
	  component: () => import('./views/index/RealNameApply3.vue')
	},
    {
      path: '/backup',
      name: 'Backup',
      component: () => import('./views/index/Backup.vue')
    },
    {
      path: '/mnemonicWord',
      name: 'MnemonicWord',
      component: () => import('./views/index/MnemonicWord.vue')
    },
    {
        path: "/createWalletPassword",
        name: "Create Wallet Password",
        component: () => import("./views/index/hdWallet/CreateWalletPassword.vue"),
      },
      {
        path: "/enterHdWalletPassword",
        name: "Enter Wallet Password",
        component: () => import("./views/index/hdWallet/EnterHdWalletPassword.vue"),
      },
    {
      path: '/safety',
      name: 'Safety',
      component: () => import('./views/index/Safety.vue')
    },
    {
      path: '/lookWords',
      name: 'LookWords',
      component: () => import('./views/index/LookWords.vue')
    },
    {
      path: '/selectWords',
      name: 'SelectWords',
      component: () => import('./views/index/SelectWords.vue')
    },
    {
      path: '/coinAgaList',
      name: 'CoinAgaList',
      component: () => import('./views/index/CoinAgaList.vue')
    },
    {
      path: '/sendEnvelope',
      name: 'SendEnvelope',
      component: () => import('./views/index/SendEnvelope.vue')
    },
    {
      path: '/redCoinList',
      name: 'RedCoinList',
      component: () => import('./views/index/RedCoinList.vue')
    },
    {
        path: '/discount-buy',
        name: 'Discount Buy',
        component: () => import('./views/index/DiscountBuy.vue')
      },
    {
      path: '/redEnvelopeRecord',
      name: 'RedEnvelopeRecord',
      component: () => import('./views/index/RedEnvelopeRecord.vue')
    },
    {
        path: "/transactions/:address",
        name: "transactions",
        props:true,
        component: () => import("./views/index/hdWallet/transactions/TransactionWrapper.vue"),
      },
    {
      path: '/hDsearch',
      name: 'HDsearch',
      component: () => import('./views/index/HDsearch.vue')
    },
    {
      path: '/redEnvelopeDetail',
      name: 'RedEnvelopeDetail',
      component: () => import('./views/index/RredEnvelopeDetail.vue')
    },
    {
      path: '/hangqingAdd',
      name: 'hangqingAdd',
      component: () => import('./views/hangqing/Add.vue')
    },
    {
      path: '/hangqingSort',
      name: 'hangqingSort',
      component: () => import('./views/hangqing/Sortable.vue')
    },
    {
      path: '/faxian',
      name: 'Faxian',
      component: () => import('./views/faxian/Index.vue')
    },
    {
      path: '/faxiantype',
      name: 'FaxianType',
      component: () => import('./views/faxian/TypeList.vue')
    },
    {
      path: '/dappwallet',
      name: 'Dappwallet',
      component: () => import('./views/faxian/Dappwallet.vue')
    },
    {
      path: '/share',
      name: 'Share',
      component: () => import('./views/wode/Share.vue')
    },
    {
      path: '/shequn',
      name: 'Shequn',
      component: () => import('./views/wode/Shequn.vue')
    },
    {
      path: '/invitationDetail',
      name: 'InvitationDetail',
      component: () => import('./views/wode/InvitationDetail.vue')
    },
    {
      path: '/mycc',
      name: 'Mycc',
      component: () => import('./views/wode/Mycc.vue')
    },
    {
      path: '/task',
      name: 'Task',
      component: () => import('./views/wode/Task.vue')
    },
    {
      path: '/shop',
      name: 'Shop',
      component: () => import('./views/wode/Shop.vue')
    },
    {
      path: '/shopinfo',
      name: 'Shopinfo',
      component: () => import('./views/wode/Shopinfo.vue')
    },
    {
      path: '/myccorder',
      name: 'Myccorder',
      component: () => import('./views/wode/Myccorder.vue')
    },
    {
      path: '/shoporder',
      name: 'Shoporder',
      component: () => import('./views/wode/Shoporder.vue')
    },
    {
      path: '/taskorder',
      name: 'Taskorder',
      component: () => import('./views/wode/Taskorder.vue')
    },
    {
      path: '/pinset',
      name: 'PinSet',
      component: () => import('./views/wode/PinSet.vue')
    },
    {
      path: '/pincheck',
      name: 'PinCheck',
      component: () => import('./views/wode/PinCheck.vue')
    },
    {
      path: '/huobi',
      name: 'Huobi',
      component: () => import('./views/wode/Huobi.vue')
    },
    {
      path: '/invite',
      name: 'Invite',
      component: () => import('./views/wode/Invite.vue')
    },
    {
      path: '/onequan',
      name: 'Onequan',
      component: () => import('./views/wode/Onequan.vue')
    },
    {
      path: '/redgreen',
      name: 'RedGreen',
      component: () => import('./views/wode/RedGreen.vue')
    },
    {
      path: '/zixun',
      name: 'Zixun',
      component: () => import('./views/wode/Zixun.vue')
    },
    {
      path: '/pos',
      name: 'Pos',
      component: () => import('./views/wealth/Pos.vue')
    },
    {
      path: '/coinplan',
      name: 'Coinplan',
      component: () => import('./views/wealth/Coinplan.vue')
    },
    {
      path: '/mywealth',
      name: 'Mywealth',
      component: () => import('./views/wealth/Mywealth.vue')
    },
    {
      path: '/plandetail',
      name: 'Plandetail',
      component: () => import('./views/wealth/Plandetail.vue')
    },
    {
      path: '/buyploy',
      name: 'Buyploy',
      component: () => import('./views/wealth/Buyploy.vue')
    },
    {
      path: '/sellploy',
      name: 'Sellploy',
      component: () => import('./views/wealth/Sellploy.vue')
    },
    {
      path: '/ploydetail',
      name: 'Ploydetail',
      component: () => import('./views/wealth/Ploydetail.vue')
    },
   
    {
      path: '/query',
      name: 'Query',
      component: () => import('./views/wealth/Query.vue')
    },
    {
      path: '/info',
      name: 'Info',
      component: () => import('./views/wealth/Info.vue')
    },
    {
      path: '/buyAU',
      name: 'BuyAU',
      component: () => import('./views/wealth/BuyAU.vue')
    },
    {
      path: '/404',
      component: () => import('@/views/errorPage/404')
    },
    {
      path: '/setlang',
      name: 'SetLang',
      component: () => import('./views/wode/SetLang.vue')
    },
    {
      path: '/faq',
      name: 'Faq',
      component: () => import('./views/wode/Faq.vue')
    },
    {
      path: '/faqitem1',
      name: 'FaqItem1',
      component: () => import('./views/wode/faq/FaqItem1.vue')
    },
    {
      path: '/faqitem2',
      name: 'FaqItem2',
      component: () => import('./views/wode/faq/FaqItem2.vue')
    },
    {
      path: '/faqitem3',
      name: 'FaqItem3',
      component: () => import('./views/wode/faq/FaqItem3.vue')
    },
    {
      path: '/faqitem4',
      name: 'FaqItem4',
      component: () => import('./views/wode/faq/FaqItem4.vue')
    },
    {
      path: '/faqitem5',
      name: 'FaqItem5',
      component: () => import('./views/wode/faq/FaqItem5.vue')
    },
    {
      path: '/faqitem6',
      name: 'FaqItem6',
      component: () => import('./views/wode/faq/FaqItem6.vue')
    },
    {
      path: '/faqitem7',
      name: 'FaqItem7',
      component: () => import('./views/wode/faq/FaqItem7.vue')
    },
    {
      path: '/faqitem8',
      name: 'FaqItem8',
      component: () => import('./views/wode/faq/FaqItem8.vue')
    },
    {
      path: '/faqitem9',
      name: 'FaqItem9',
      component: () => import('./views/wode/faq/FaqItem9.vue')
    },
    {
      path: '/faqitem10',
      name: 'FaqItem10',
      component: () => import('./views/wode/faq/FaqItem10.vue')
    },
    {
      path: '/faqitem11',
      name: 'FaqItem11',
      component: () => import('./views/wode/faq/FaqItem11.vue')
    },
    {
      path: '/faqitem12',
      name: 'FaqItem12',
      component: () => import('./views/wode/faq/FaqItem12.vue')
    },
    {
      path: '/faqitem13',
      name: 'FaqItem13',
      component: () => import('./views/wode/faq/FaqItem13.vue')
    },
    {
      path: '/faqitem14',
      name: 'FaqItem14',
      component: () => import('./views/wode/faq/FaqItem14.vue')
    },
    {
      path: '/faqitem15',
      name: 'FaqItem15',
      component: () => import('./views/wode/faq/FaqItem15.vue')
    },
    {
      path: '/helpcenter',
      name: 'HelpCenter',
      component: () => import('./views/wode/HelpCenter.vue')
    },
    {
      path: '/serviceagreement',
      name: '/ServiceaAgreement',
      component: () => import('./views/wode/ServiceAgreement.vue')
    },
    {
      path: '/privacypolicy',
      name: '/PrivacyPolicy',
      component: () => import('./views/wode/PrivacyPolicy.vue')
    },
    //{
    //    path: '/hdWallet/',
    //    name: 'Hd Wallet',
    //    component: () => import('./views/index/hdWallet/Index.vue')
    //  },
  ]
})

router.beforeEach((to, from, next) => {
  if (Object.keys(store.state.initInfo).length != 0) {
    myNext(to, from, next)
  } else {
    getInitInfo(to, from, next)
  }
})

function getInitInfo(to, from, next) {
  //网络请求太慢白屏，不等网络请求直接进页面
  myNext(to, from, next)
  httpGetInitInfo().then((res) => {
    store.dispatch('setInitInfo', res.data)
    //myNext(to, from, next)
  }).catch((e) => {
    //myNext(to, from, next)
    //console.log(e)
    //getInitInfo(to, from, next)
  })
}

function getUserInfo(to, from, next) {
  httpGetUserInfo().then((res) => {
	console.log('getUserInfo getUserInfo', res)
    store.dispatch('setUserInfo', res.data)
	localStorage.setItem("loginUserAccid",res.data.accid)
    next(to, from, next)
  }).catch((code) => {
    if(code == 10001){
      store.dispatch("removeToken");
      next({
      path: '/'
    })}
  })
}
//const needChangeBar = ['/index/home','/index/nologin','/CoinPurse','/index/wealth','/share']
function myNext(to, from, next) {
  // if(needChangeBar.indexOf(to.path) != -1){
  //   setStatusBar('#046afd')
  // }else{
  //   setStatusBar('#ffffff')
  // }
  if (getToken()) {
    if (Object.keys(store.state.userInfo).length == 0) {
      getUserInfo(to, from, next)
    } 
    next()
  } else {
    if (needLoginList.indexOf(to.path) !== -1) { 
      next(`/?redirect=${to.path}`) 
    } else {
      next() 
    }
  }
}

export default router